<template>
  <div>
    <h3>
      <b>{{ $t('FAQ.ownerConnect') }}</b>
    </h3>
    <hr />
    <h3>
      <b>19.1 Owner Connect melalui Aplikasi Mobile (iOS/Android)</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih tombol “Owner Connect” di halaman muka aplikasi Agen BeliRumah anda.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_75.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Di halaman Listing Owner, silahkan pilih listing yang menarik minat anda untuk bantu jual
        dan tekan tombol ”Lihat Kontak”
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_76_2.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>Listing yang anda pilih akan masuk menu “Favorit Saya”</li>
      <br />
      <li>
        Selanjutnya tekan tombol chat WA maka anda akan langsung terhubung melalui Whatsapp dengan
        Owner Pemilik Listing tersebut.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_77_2.jpg"
            alt=""
          />
        </div>
      </li>
    </ul>
    <hr />
    <h3>
      <b>19.2 Owner Connect melalui Browser Laptop/PC</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih menu “Fitur Unggulan” dan klik tombol “Owner Connect” di halaman muka Menu Bar Agen
        BeliRumah anda.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/desktop/desktop_owner_connect_4_2.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Di halaman Listing Owner, silahkan pilih listing yang menarik minat anda untuk bantu jual
        dan tekan tombol ”Pilih untuk lihat kontak”
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/desktop/desktop_owner_connect_5_2.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Listing yang anda pilih akan masuk menu “Favorit Saya”
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/desktop/desktop_owner_connect_6_2.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Selanjutnya tekan tombol chat WA maka anda akan langsung terhubung melalui Whatsapp dengan
        Owner Pemilik Listing tersebut.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/desktop/desktop_owner_connect_7_2.jpg"
            alt=""
          />
        </div>
      </li>
    </ul>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'OwnerConnect',
};
</script>

<style></style>
